import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/trash_16.svg.ts
import { svg } from "lit";
var trash16Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M13 4V13.625C13 13.9897 12.8551 14.3394 12.5973 14.5973C12.3394 14.8551 11.9897 15 11.625 15H4.375C4.01033 15 3.66059 14.8551 3.40273 14.5973C3.14487 14.3394 3 13.9897 3 13.625V4H13Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2 4H3.33333H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.5 4V2.25C5.5 1.91848 5.6317 1.60054 5.86612 1.36612C6.10054 1.1317 6.41848 1 6.75 1H9.25C9.58152 1 9.89946 1.1317 10.1339 1.36612C10.3683 1.60054 10.5 1.91848 10.5 2.25V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.5 7.5V11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.5 7.5V11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  trash16Svg
};
//# sourceMappingURL=trash_16.svg-TZDW5QXS.js.map
